import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AccountSidebar.css';

/**
 * AccountSidebar component - Reusable sidebar navigation for account pages
 * Shows menu items: Personal Information, Saved Address, Purchase History, Email Notifications
 * Highlights the current active page
 */
function AccountSidebar() {
    const location = useLocation();
    const { logOut } = useAuth();

    const handleLogout = async () => {
        const result = await logOut();
        if (result.error) {
            console.error('Logout error:', result.error);
        }
    };

    const menuItems = [
        { path: '/account/personal-information', label: 'Personal Information' },
        { path: '/account/saved-address', label: 'Saved Address' },
        { path: '/account/purchase-history', label: 'Purchase History' },
        { path: '/account/email-notifications', label: 'Email Notifications' }
    ];

    return (
        <aside className="account-sidebar">
            <nav className="sidebar-menu">
                {menuItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
                    >
                        {item.label}
                    </Link>
                ))}
            </nav>

            <button className="sidebar-logout" onClick={handleLogout}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                <span>Log Out</span>
            </button>
        </aside>
    );
}

export default AccountSidebar;